// 关注领域
export const areas = [
  {
    id: 2,
    name: "平面设计",
    code: "designer",
    icon: "https://hbfile.huaban.com/img/jobs/pm.png",
    jobName: "平面设计师",
    user_id: 31089818,
  },
  {
    id: 1,
    name: "电商设计",
    code: "e-commerce_designer",
    icon: "https://hbfile.huaban.com/img/jobs/ds.png",
    jobName: "电商设计师",
    user_id: 31089817,
  },
  {
    id: 5,
    name: "UI/UX设计",
    code: "ui_designer",
    icon: "https://hbfile.huaban.com/img/jobs/ui.png",
    jobName: "UI/UX设计师",
    user_id: 31089821,
  },
  {
    id: 8,
    name: "插画/漫画",
    code: "illustrator",
    icon: "https://hbfile.huaban.com/img/jobs/ch.png",
    jobName: "插画/漫画师",
    user_id: 31203029,
  },
  {
    id: 12,
    name: "摄影",
    code: "photographer",
    icon: "https://hbfile.huaban.com/img/jobs/sy.png",
    jobName: "摄影师",
    user_id: 33751372,
  },
  {
    id: 11,
    name: "3D设计",
    code: "3D_designer",
    icon: "https://hbfile.huaban.com/img/jobs/3d.png",
    jobName: "3D设计师",
    user_id: 33751371,
  },
  {
    id: 4,
    name: "工业设计",
    code: "industrial_designer",
    icon: "https://hbfile.huaban.com/img/jobs/gy.png",
    jobName: "工业设计师",
    user_id: 31089820,
  },
  {
    id: 6,
    name: "游戏设计",
    code: "game_designer",
    icon: "https://hbfile.huaban.com/img/jobs/yx.png",
    jobName: "游戏设计师",
    user_id: 31089822,
  },
  {
    id: 3,
    name: "室内设计",
    code: "interior_designer",
    icon: "https://hbfile.huaban.com/img/jobs/sn.png",
    jobName: "室内设计师",
    user_id: 31089819,
  },
  {
    id: 7,
    name: "建筑设计",
    code: "architect",
    icon: "https://hbfile.huaban.com/img/jobs/jz.png",
    jobName: "建筑设计师",
    user_id: 31089823,
  },
  {
    id: 9,
    name: "景观设计",
    code: "landscape_designer",
    icon: "https://hbfile.huaban.com/img/jobs/jg.png",
    jobName: "景观设计师",
    user_id: 33751369,
  },
  {
    id: 10,
    name: "动画",
    code: "animator",
    icon: "https://hbfile.huaban.com/img/jobs/dh.png",
    jobName: "动画师",
    user_id: 33751370,
  },
  {
    id: 13,
    name: "服装设计",
    code: "costume_designer",
    icon: "https://hbfile.huaban.com/img/jobs/fz.png",
    jobName: "服装设计师",
    user_id: 33751373,
  },
  {
    id: 14,
    name: "造型设计",
    code: "stylist",
    icon: "https://hbfile.huaban.com/img/jobs/zx.png",
    jobName: "造型设计师",
    user_id: 33751374,
  },
  {
    id: 15,
    name: "手工艺",
    code: "artisan",
    icon: "https://hbfile.huaban.com/img/jobs/sgy.png",
    jobName: "手工艺人",
    user_id: 33751375,
  },
  {
    id: 16,
    name: "纯艺术",
    code: "artist",
    icon: "https://hbfile.huaban.com/img/jobs/cys.png",
    jobName: "艺术工作者",
    user_id: 33751376,
  },
];

export const jobs = [
  ...areas,
  {
    id: 999,
    name: "其他",
    jobName: "其他",
  },
];

export function getJobId(name) {
  return jobs.find((job) => job.name == name)?.id || 999;
}

export function getJobName(id) {
  return jobs.find((job) => job.id == id)?.jobName;
}

export const MuseCategories = [
  ...areas,
  { code: "company", name: "企业", id: 999, jobName: "企业" },
  { code: "other", name: "其他", id: 999, jobName: "其他" },
];

export function getMuseName(code) {
  return MuseCategories.find((category) => category.code == code)?.jobName;
}

export function isCertifyCompany(code) {
  const data = MuseCategories.find((category) => category.code == code);
  if (data?.code == "company") {
    return true;
  }
  return false;
}
